import { useCallback } from "react";
export var defaultRecordSetNumber = 1;
export var defaultRecordSetSize = 2000;
export var getRecordSetSize = function (pageSize) {
    switch (pageSize) {
        case 20:
        case 50:
        case 100:
            return 2000;
        case 75:
            return 1950;
        default:
            return pageSize;
    }
};
export var useLoadRecordSet = function (setPageNumber, pageSize, recordSetSize) {
    return useCallback(function (recordSetNumber) {
        var rn = recordSetNumber !== null && recordSetNumber !== void 0 ? recordSetNumber : defaultRecordSetNumber;
        var rs = recordSetSize !== null && recordSetSize !== void 0 ? recordSetSize : defaultRecordSetSize;
        setPageNumber((rn - 1) * (rs / pageSize) + 1);
    }, [pageSize, recordSetSize, setPageNumber]);
};
//# sourceMappingURL=use-load-recordset.js.map